module.exports = __webpack_public_path__ + "static/img/logo.02a9261f.png";